import React, { useState } from 'react';
import { validationFlags } from '../data/mockData';

const SEVERITY_ICON = { CRITICAL: '🚫', HIGH: '⚠️', MEDIUM: '⬤', INFO: 'ℹ' };
const SEVERITY_ORDER = { CRITICAL: 0, HIGH: 1, MEDIUM: 2, INFO: 3 };

export default function ValidationFlags() {
  const [filter, setFilter] = useState('ALL');

  const sorted = [...validationFlags].sort((a, b) => SEVERITY_ORDER[a.severity] - SEVERITY_ORDER[b.severity]);
  const filtered = filter === 'ALL' ? sorted : sorted.filter(f => f.severity === filter);

  const counts = { CRITICAL: 0, HIGH: 0, MEDIUM: 0, INFO: 0 };
  validationFlags.forEach(f => counts[f.severity]++);

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <h2>Validation Flags</h2>
          <p>Step 5 — rule engine output · {counts.CRITICAL > 0 ? 'LOAD BLOCKED — resolve all CRITICAL flags to proceed' : 'No critical issues'}</p>
        </div>
        {counts.CRITICAL > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--error-bg)', border: '1px solid #f5c6c6', padding: '8px 16px', borderRadius: 'var(--radius)' }}>
            <span style={{ fontSize: 18 }}>🚫</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--error)' }}>Load Blocked — {counts.CRITICAL} Critical</span>
          </div>
        )}
      </div>

      {/* Summary counts */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
        {Object.entries(counts).map(([sev, cnt]) => (
          <button
            key={sev}
            onClick={() => setFilter(filter === sev ? 'ALL' : sev)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              background: filter === sev ? (sev === 'CRITICAL' ? 'var(--error-bg)' : sev === 'HIGH' ? 'var(--high-bg)' : sev === 'MEDIUM' ? 'var(--warning-bg)' : 'var(--info-bg)') : 'var(--surface)',
              border: `1px solid ${filter === sev ? (sev === 'CRITICAL' ? '#f5c6c6' : sev === 'HIGH' ? '#f5d0a9' : sev === 'MEDIUM' ? '#fde99c' : '#bcd0f5') : 'var(--border)'}`,
              borderRadius: 'var(--radius)',
              padding: '12px 18px',
              cursor: 'pointer',
              transition: 'all 0.15s',
            }}
          >
            <span style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700, color: sev === 'CRITICAL' ? 'var(--error)' : sev === 'HIGH' ? 'var(--high)' : sev === 'MEDIUM' ? 'var(--warning)' : 'var(--info)', lineHeight: 1 }}>{cnt}</span>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', color: sev === 'CRITICAL' ? 'var(--error)' : sev === 'HIGH' ? 'var(--high)' : sev === 'MEDIUM' ? 'var(--warning)' : 'var(--info)' }}>{sev}</div>
              <div style={{ fontSize: 11, color: 'var(--ink-4)' }}>{sev === 'CRITICAL' ? 'Blocks load' : sev === 'HIGH' ? 'Warning' : sev === 'MEDIUM' ? 'Advisory' : 'Info only'}</div>
            </div>
          </button>
        ))}
        {filter !== 'ALL' && (
          <button onClick={() => setFilter('ALL')} className="btn btn-secondary btn-sm" style={{ alignSelf: 'center' }}>
            Clear filter
          </button>
        )}
      </div>

      {/* Flag list */}
      <div className="flag-list">
        {filtered.map(flag => (
          <div key={flag.id} className={`flag-card ${flag.severity.toLowerCase()}`}>
            <div className="flag-severity-icon">
              <span>{SEVERITY_ICON[flag.severity]}</span>
            </div>
            <div className="flag-body">
              <div className="flag-top">
                <span className={`badge badge-${flag.severity === 'CRITICAL' ? 'critical' : flag.severity === 'HIGH' ? 'high' : flag.severity === 'MEDIUM' ? 'medium' : 'info'}`}>
                  {flag.severity}
                </span>
                <span className="badge badge-neutral">{flag.ruleId}</span>
                <span style={{ fontSize: 12, color: 'var(--ink-3)', fontWeight: 600 }}>{flag.employee}</span>
                {flag.blocksLoad && (
                  <span className="badge badge-critical" style={{ marginLeft: 'auto' }}>🚫 Blocks Load</span>
                )}
              </div>
              <div className="flag-msg">{flag.message}</div>
              <div className="flag-resolution">
                <strong>Resolution: </strong>{flag.resolution}
              </div>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div style={{ textAlign: 'center', padding: '48px', color: 'var(--ink-3)' }}>
          No flags for this severity level.
        </div>
      )}
    </div>
  );
}
